<div style="width:100%;" *ngIf="checklistRows && checklistRows.length > 0">
       
  <table #checklistTable mat-table [dataSource]="checklistRows" class="checklist-table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Item </th>
      <td mat-cell *matCellDef="let element"> 
        <span class='template' *ngIf="element.type === 'TEMPLATE'">{{element.name}}</span>
        <span class='item' *ngIf="element.type === 'ITEM'">&nbsp;&nbsp;{{element.name}}</span>
        <span class='appointment-name' *ngIf="element.type === 'APPOINTMENT'">{{element.name}}<span *ngIf="isAppointmentLate(element)" class="late-style"><mat-icon>notification_important</mat-icon></span></span> 
      </td>
    </ng-container>

    <ng-container matColumnDef="sequenceNum">
      <th mat-header-cell *matHeaderCellDef> # </th>
      <td mat-cell *matCellDef="let element"><span class='appointment' *ngIf="element.type === 'APPOINTMENT'" >{{element.sequenceNum}}</span>  </td>
    </ng-container>
    <ng-container matColumnDef="service">
      <th mat-header-cell *matHeaderCellDef> Service </th>
      <td mat-cell *matCellDef="let element"><span class='appointment' *ngIf="element.type === 'APPOINTMENT'" >{{element.service}}</span>  </td>
    </ng-container>


    <ng-container matColumnDef="startDateTime">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let element" class='appointment'> {{element.startDateTime | date:'short'}} </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element"><span class='appointment' *ngIf="element.type === 'APPOINTMENT'" >{{element.status}}</span>  </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef> Description </th>
      <td mat-cell *matCellDef="let element"><span class='appointment' *ngIf="element.type === 'APPOINTMENT'" >{{element.description}}</span>  </td>
    </ng-container>
    <ng-container matColumnDef="workerScore">
      <th mat-header-cell *matHeaderCellDef> Score </th>
      <td mat-cell *matCellDef="let element"><span class='appointment' *ngIf="element.type === 'APPOINTMENT'" >{{element.workerScore}}</span>  </td>
    </ng-container>
    <ng-container matColumnDef="managerScore">
      <th mat-header-cell *matHeaderCellDef> Coordinator Score </th>
      <td mat-cell *matCellDef="let element"><span class='appointment' *ngIf="element.type === 'APPOINTMENT'" >{{element.managerScore}}</span>  </td>
    </ng-container>
    <ng-container matColumnDef="workerNotes">
      <th mat-header-cell *matHeaderCellDef> Notes </th>
      <td mat-cell *matCellDef="let element"><span class='appointment' *ngIf="element.type === 'APPOINTMENT'" >{{element.workerNotes}}</span>  </td>
    </ng-container>
    <ng-container matColumnDef="managerNotes">
      <th mat-header-cell *matHeaderCellDef> Coordinator Notes </th>
      <td mat-cell *matCellDef="let element"><span class='appointment' *ngIf="element.type === 'APPOINTMENT'" >{{element.managerNotes}}</span>  </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr (click)="onRowSelect(row)" mat-row *matRowDef="let row; columns: displayColumns;" >
    </tr>
  </table>
</div>